import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

const typeStyles = {
  primary: {
    surface: 'bg-cs-navy-600 rounded-cs-10 shadow-lg',
    heading: 'text-white',
    body: 'text-white'
  },
  inverted: {
    surface: 'bg-transparent',
    heading: 'text-cs-gray-900',
    body: 'text-cs-gray-900'
  },
  alt: {
      surface: 'bg-[#4E5A20]/10 rounded-cs-10 shadow-lg',
      heading: 'text-[#4E5A20]',
      body: 'text-[#4E5A20]'
  }
};

CtaGroup.propTypes = {
  type: PropTypes.oneOf(Object.keys(typeStyles)),
  heading: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  buttonLabel: PropTypes.node.isRequired,
  onButtonClick: PropTypes.func,
  primaryHref: PropTypes.string,
};

export default function CtaGroup(props) {
  const {
    type = 'primary',
    heading,
    body,
    buttonLabel,
    onButtonClick,
    primaryHref
  } = props;

  const t = typeStyles[type] ?? typeStyles.primary;

  return (
    <section className={classNames('w-full max-w-screen-xl mx-auto px-6 py-6 flex flex-col', t.surface)}>
      <h2 className={classNames(t.heading, 'font-semibold text-3xl leading-tight')}>
        {heading}
      </h2>
      <p className={classNames('mt-3 font-normal text-base leading-tight', t.body)}>
        {body}
      </p>
      <div className="mt-6 flex justify-stretch md:justify-end">
        {type === 'inverted' && <SecondaryButton onClick={onButtonClick}>{buttonLabel}</SecondaryButton>}
        {type === 'primary' && <PrimaryButton variant="inverted" href={primaryHref} onClick={onButtonClick}>{buttonLabel}</PrimaryButton>}
        {type === 'alt' && <SecondaryButton href={primaryHref} onClick={onButtonClick}>{buttonLabel}</SecondaryButton>}
      </div>
    </section>
  );
}
